/* candlogic-easify-variant-fix.js
   Purpose: Easify is applying inline display:none to Dawn's variant-selects and sometimes the quantity form.
   This keeps them visible. Safe: only runs on product pages where these elements exist.
*/

(function candlogicEasifyVariantFix() {
  function candlogicUnhide(el) {
    if (!el) return;

    // Remove inline display hiding
    if (el.style && (el.style.display === "none" || el.getAttribute("style")?.includes("display"))) {
      el.style.removeProperty("display");
      el.style.display = "";
    }

    // If still hidden due to CSS, force it visible (last resort)
    const cs = window.getComputedStyle(el);
    if (cs.display === "none") {
      el.style.setProperty("display", "block", "important");
    }
  }

  function candlogicRun() {
    // Dawn variant picker custom element
    document.querySelectorAll("variant-selects").forEach(candlogicUnhide);

    // Dawn quantity form block
    document.querySelectorAll('[id^="Quantity-Form-"]').forEach(candlogicUnhide);
  }

  // Run asap and after apps initialize
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", candlogicRun, { once: true });
  } else {
    candlogicRun();
  }
  window.addEventListener("load", candlogicRun);

  // Keep it unhidden if an app re-hides it later
  const candlogicObserver = new MutationObserver(function () {
    candlogicRun();
  });

  candlogicObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["style", "class"],
    subtree: true
  });
})();
